const GetWeekdaysOfMonth = (): number => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const weekdays: Date[] = [];
  const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();

  for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(currentYear, currentMonth - 1, day);
      const dayOfWeek = date.getDay();

      // Check if it's a weekday (Monday to Friday)
      if (dayOfWeek > 0 && dayOfWeek < 6) {
          weekdays.push(date);
      }
  }

  return weekdays.length;
}

export { GetWeekdaysOfMonth }
